import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SettingsNavigation from "@Shared/components/settings/settings-navigation";
import PageHeader from "@Shared/components/general/page-header";
import SimpleButton from "@Shared/components/buttons/simple-button.vue";
import BrokerageTab from "./brokerage/components/brokerage-tab";
import FaqTab from "./faq/components/faq-tab";
import ApplicationDisclaimers from "./disclaimers/components/application-disclaimers";
import ApplicationVisibility from "./application-form/components/application-visibility";
import ThemesTab from "./themes/components/themes-tab";
import CoBrokeringTab from "./co-brokering/co-brokering-tab";
import BoardsTab from "./boards/components/boards-tab";
import { LOAD_BROKERAGE_OVERRIDES } from "./store/settings-actions";
import { SET_THEME_PREVIEW } from "./store/settings-mutations";
import { mapActions, mapMutations, mapState } from "vuex";
import permissionsMixin from "./mixins/permissions-mixin";
import settingsMixin from "./mixins/settings-mixin";
import SettingsLoader from "./settings-loader.vue";
import Amplitude from "@Shared/@Utils/amplitude";
import { isEmpty } from "lodash";
import ResetVisibilitySettingsModal from "./application-form/components/reset-visibility-modal";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "BrokerageSettingsContainer",
  title() {
    return this.$t("sidebar.sections.brokerageSettings");
  },
  components: {
    SimpleButton,
    PageHeader,
    SettingsNavigation,
    BrokerageTab,
    ThemesTab,
    FaqTab,
    ApplicationDisclaimers,
    ApplicationVisibility,
    SettingsLoader,
    ResetVisibilitySettingsModal,
    CoBrokeringTab,
    BoardsTab
  },
  mixins: [permissionsMixin, settingsMixin],
  props: {
    tab: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      loading: false,
      currentTab: "",
      saving: false,
      resetting: false,
      savingStatus: false,
      resettingStatus: false,
      allowSave: false,
      settingsType: "brokerage-settings" //Needed for permissions mixin
    };
  },
  computed: _objectSpread(_objectSpread(_objectSpread({}, mapState("SettingsStore", ["isOnThemePreviewMode", "overrides", "loadingState"])), mapState("ApplicationStore", {
    isDefaultSchema(state) {
      return state.customizationSchema.isDefaultSchema;
    }
  })), {}, {
    loadingAny() {
      return this.loading || this.loadingState;
    },
    tabs() {
      return [{
        key: "brokerage",
        label: this.$t("settings.tabs.brokerage"),
        disabled: this.getTabDisabledOption({
          key: "brokerage"
        }),
        component: "brokerage-tab"
      }, {
        key: "co-brokering",
        label: this.$t("settings.tabs.co-brokering"),
        disabled: this.getTabDisabledOption({
          key: "co-brokering"
        }),
        component: "co-brokering-tab"
      }, {
        key: "theme",
        label: this.$t("settings.tabs.theme"),
        disabled: this.getTabDisabledOption({
          key: "theme",
          override: "overrideStyle"
        }),
        component: "themes-tab"
      }, {
        key: "application-form",
        label: this.$t("settings.tabs.applicationForm"),
        disabled: this.getTabDisabledOption({
          key: "application-form",
          override: "overrideForm"
        }),
        component: "application-visibility"
      }, {
        key: "disclaimers",
        label: this.$t("settings.tabs.disclaimers"),
        disabled: this.getTabDisabledOption({
          key: "disclaimers",
          override: "overrideForm"
        }),
        component: "application-disclaimers"
      }, {
        key: "boards",
        label: this.$t("settings.tabs.boards"),
        disabled: this.getTabDisabledOption({
          key: "boards",
          override: "overrideForm"
        }),
        component: "boards-tab"
      }, {
        key: "faq",
        label: this.$t("settings.tabs.FAQ"),
        disabled: this.getTabDisabledOption({
          key: "faq",
          override: "overrideFaq"
        }),
        component: "faq-tab"
      }];
    },
    allowReset() {
      return !this.isDefaultSchema;
    }
  }),
  beforeMount() {
    Amplitude.logEvent("Brokerage Settings - visited");
  },
  async mounted() {
    this.setInitialCurrentTab();
    if (!isEmpty(this.overrides) && this.$route.name !== "brokerage-settings") return; // There's no need to load
    this.loading = true;
    if (isEmpty(this.overrides)) await this.LOAD_BROKERAGE_OVERRIDES();
    this.loading = false;
  },
  methods: _objectSpread(_objectSpread(_objectSpread({}, mapActions("SettingsStore", [LOAD_BROKERAGE_OVERRIDES])), mapMutations("SettingsStore", [SET_THEME_PREVIEW])), {}, {
    handleTabChange(tab) {
      this.currentTab = tab;
      this.allowSave = false;
      Amplitude.logEvent(`Brokerage Settings - ${tab} visited`);
    },
    startSaving() {
      this.saving = true;
    },
    showResetVisibilitySettingsModal() {
      this.$refs.resetVisibilitySettingsModal.showModal();
    },
    startResetting() {
      this.resetting = true;
    },
    finishSaving(savingStatus) {
      this.saving = false;
      this.savingStatus = savingStatus;
      this.allowSave = false;
    },
    finishResetting(resettingStatus) {
      this.resetting = false;
      this.resettingStatus = resettingStatus;
    },
    handleAllowSave(canSave) {
      this.allowSave = canSave;
    },
    handlePreviewTheme() {
      this.SET_THEME_PREVIEW({
        previewMode: true,
        previewModeSource: "brokerage-settings"
      });
    },
    setInitialCurrentTab() {
      const queryTab = this.$route.query.tab;
      const metaTab = this.$route.meta.tab;
      this.currentTab = queryTab || metaTab || this.tabs[0].key;
      Amplitude.logEvent(`Brokerage Settings - ${this.currentTab} visited`);
    }
  })
});